export default (src) => {
  if (typeof src !== 'string' || !src) {
    return false;
  }

  return /^\/spaces\/api\/v\d+\/spaces\/?/.test(src);
};
